// The solar journey runs for more than one supplier on the same subcategory, so
// the subcat cannot tell them apart; the supplier is read from the matched
// collection's supplierId instead. The consent copy names the supplier, so each
// id maps to its display name. An unknown id uses a generic provider name rather
// than naming the wrong supplier in a consent line.
const SOLAR_SUPPLIER_NAMES = {
  '6f5c166e-742c-11ef-945e-0a58a9feac02': 'Lime',
  '0c9dd5a5-6aa2-4cf5-b369-caa4eea6e314': 'Project Solar',
};

const DEFAULT_SOLAR_SUPPLIER_NAME = 'your solar provider';

export const getSolarSupplierName = (supplierId) =>
  SOLAR_SUPPLIER_NAMES[supplierId] ?? DEFAULT_SOLAR_SUPPLIER_NAME;

export default SOLAR_SUPPLIER_NAMES;
